import { useSyncExternalStore } from 'react'
import type { ScreenState } from '../../../types/state'
import { getScreenState } from '../../state/getState'
import { pubSubScreen } from '../../state/pubSub'

const subScreenOrientation = (cb) => pubSubScreen.on('state', cb)
const getScreenStateSelector =
    <T extends keyof ScreenState>(
        attribute: T,
        defaultValue?: ScreenState[T],
    ) =>
    () => {
        // console.log('[getScreenStateSelector]', getScreenState())
        return getScreenState()[attribute] ?? defaultValue
    }

export const useScreenStateSelector = <T extends keyof ScreenState>(
    attribute: T,
    defaultValue?: ScreenState[T],
): ScreenState[T] => {
    return useSyncExternalStore(
        subScreenOrientation,
        getScreenStateSelector(attribute, defaultValue),
        getScreenStateSelector(attribute, defaultValue),
    )
}
